import { TableRow, TableCell } from "@mui/material";
import { IRow } from "../types";

export const form5HeaderRows = (
    <>
        <TableRow>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} colSpan={2}>
                Результат предоставления Субсидии
            </TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} rowSpan={2}>
                Плановые значения
            </TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} rowSpan={2}>
                Размер субсидии, предусмотренной соглашением, руб.
            </TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} rowSpan={2}>
                Фактически достигнутые значения
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{ whiteSpace: "pre-wrap" }}>тип результата*</TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }}>наименование*</TableCell>
        </TableRow>
    </>
);

export const form5Rows: IRow[] = [
    {
        col1: "Оказание услуг (выполнение работ)",
        col2: "Создание и развитие центров прототипирования",
        col3: { name: "info.f5.0" },
        col4: { name: "info.f5.1", numeric: true },
        col5: { name: "info.f5.2" },
    },
];
